'use client'

import type { ServerDataCardProps } from "./Types"
import { Card, CardBody } from "@heroui/card"
import { useDisclosure } from "@heroui/react"
import ServerDataModal from "molecules/ServerDataModal"
export default function ServerDataCard({
  className,
}: Readonly<ServerDataCardProps>) {
  const { isOpen, onOpen, onOpenChange } = useDisclosure()

  return (
    <>
      <Card isPressable onPress={onOpen} className={className}>
        <CardBody className="flex flex-col items-center justify-center text-white/70 hover:text-white/90">
          Zeige Server Daten
        </CardBody>
      </Card>
      <ServerDataModal isOpen={isOpen} onOpenChange={onOpenChange} />
    </>
  )
}
